import React from "react";
import TrackedSelectedRows from "./TrackedSelectedRows";
import trans from "../../../../utils";

export default function TrackedSelectedCamera() {
	return (
		<div className="object-selected-camera">
			<TrackedSelectedRows title={trans("total cameras")} item="2" />
			<div className="w-100">
				<div className="flex-between">
					<div>
						<img
							width={160}
							src={`${process.env.PUBLIC_URL}/assets/FrontCamera.svg`}
							alt=""
						/>
					</div>
					<div>
						<img
							width={160}
							src={`${process.env.PUBLIC_URL}/assets/FrontCamera.svg`}
							alt=""
						/>
					</div>
				</div>
			</div>
		</div>
	);
}
